<script lang="ts">
  import { Step } from '@skeletonlabs/skeleton';

  /** Default: `false` */
  export let locked = false;
  /** Default: `undefined` */
  export let title: string = undefined;
</script>

<Step {locked} regionHeader={title ? '' : '-mt-12 collapse'}>
  <svelte:fragment slot="header">{title}</svelte:fragment>
  <slot />
  <div class="pb-1" />
</Step>
